import classnames from 'classnames'
import { getIntegrationDisplayName, IntegrationServiceId } from '../common/integrations'
import { IntegrationRequirementMessage } from '../common/IntegrationRequirementMessage'
import { useIntegrationRequirement } from '../common/useIntegrationRequirement'
import { IntegrationIcon } from './IntegrationIcon'
import { InteractiveTooltip } from './InteractiveTooltip/InteractiveTooltip'
import styles from './AccountAwareIntegrationIcon.module.scss'

interface AccountAwareIntegrationIconProps {
  serviceId: IntegrationServiceId
  width?: string | number
  height?: string | number
  className?: string
}

export const AccountAwareIntegrationIcon: React.FC<AccountAwareIntegrationIconProps> = ({ serviceId, width, height, className }) => {
  const checkRequirement = useIntegrationRequirement()
  const { satisfied } = checkRequirement(serviceId)
  const displayName = getIntegrationDisplayName(serviceId)

  const tooltipContent = satisfied ? displayName : <IntegrationRequirementMessage serviceId={serviceId} isTooltip />

  return (
    <InteractiveTooltip content={tooltipContent} offset={[0, 16]}>
      <IntegrationIcon
        serviceId={serviceId}
        width={width}
        height={height}
        className={classnames(className, { 'opacity-50': !satisfied, [styles.unsatisfied]: !satisfied })}
      />
    </InteractiveTooltip>
  )
}
